import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMariadbfoundationComponent } from './simple-icons-mariadbfoundation.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMariadbfoundationComponent ],
    exports:      [ SimpleIconsMariadbfoundationComponent ],
    bootstrap:    []
})
export class SimpleIconsMariadbfoundationModule {}
